import { Component, Input, OnInit, Output, EventEmitter,  ChangeDetectorRef, OnDestroy, DestroyRef, inject, signal } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HotelreviewComponent } from '@app/components/modals/hotelreview/hotelreview.component';
import { MapcomponentComponent } from '@app/components/modals/mapcomponent/mapcomponent.component';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Hotel } from '@app/models/hotels/Hotel';
import { HotelOffer } from '@app/models/hotels/HotelOffer';
import { HotelReviewsResponse } from '@app/models/hotels/HotelReviewsResponse';
import { CommonOffer } from '@app/models/offers/CommonOffer';
import { AcvisService } from '@app/services/acvis.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { EncryptionService } from '@app/services/encyption.service';
import { FavoritesService } from '@app/services/favorites.service';
import { TrafficsService } from '@app/services/traffics.service';
import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { MediaService } from '@app/services/media.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-recommendationcard',
    templateUrl: './recommendationcard.component.html',
    styleUrls: ['./recommendationcard.component.scss'],
    standalone: false
})
export class RecommendationcardComponent implements OnInit {
    @Input() hotel: Hotel;
    @Input() giataIdG: string;
    @Input() tmp_realparams: ParamFilters;
    @Output() removeHotel: EventEmitter<string> = new EventEmitter<string>();
    realparams: ParamFilters;

    firstOffer: CommonOffer;
    dauer: string = '';
    prs: string = '';
    categoryAr: number[] = [];
    loading: boolean = true;
    inFavorites: boolean = false;
    hotelReviewList: HotelReviewsResponse;


    start: string;
    end: string;
    fixinfo: boolean = false;
    shareLink = signal<string>('');
    higherPricePr = signal<string>('');
    higherPrice = signal<number>(0);
    curprice = signal<number>(0);
    imageList = signal<string[]>([]);

    destroyRef = inject(DestroyRef);
    flexinfo: string = 'Für dieses Hotel gibt es Angebote mit flexiblen Stornierungs- und Umbuchungsmöglichkeiten.';
    specialinfo: string = 'Für dieses Hotel gibt es Angebote mit Sonderaktionen (z.B. Rabatte, Kinderfestpreise oder andere Vorteile).';

    constructor(
        protected trafficsService: TrafficsService,
        protected mediaService: MediaService,
        protected dialog: MatDialog,
        protected encservice: EncryptionService,
        protected favoritesService: FavoritesService,
        protected router: Router,
        protected guardService: AuthGuardService,
        protected acvisService: AcvisService,
        protected cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.realparams = JSON.parse(JSON.stringify(this.tmp_realparams));
        this.initFilters();
        this.getGiataReviews();
        this.getGiataMedia();
        this.inFavorites = this.favoritesService.inFavorites(this.hotel?.code);
    }

    async checkRed() {
        if (this.hotel?.offerList?.length > 0) {
            this.higherPrice.set(this.getMaxPrice(this.hotel.offerList));
            if (!isNaN(Number(this.higherPrice)) && !isNaN(Number(this.hotel?.bestPricePerPerson?.value))) {
                this.curprice.set(Number(this.hotel?.bestPricePerPerson?.value));
                const prc = 100 - (Number(100 * Number(this.hotel?.bestPricePerPerson?.value)) / Number(this.higherPrice));
                if (prc >= 15 && prc <= 55) {
                    this.higherPricePr.set((prc).toFixed(0));
                } else {
                    this.higherPrice = null;
                }
            }
        }
    }

    getMaxPrice(list: HotelOffer[]): number {
        let max = 0;
        for (let i = 0; i < list.length; i++) {
            if (max < Number(list[i].personPrice.value)) {
                max = Number(list[i].personPrice.value);
            }
        }
        return max;
    }

    initFilters(): void {
        this.start = this.realparams?.reisezeitraumResult.start;
        this.end = this.realparams?.reisezeitraumResult.end;

        const nbrp = Number(this.realparams?.reisendeResult.adults) + (this.realparams?.reisendeResult.children?.length > 0 ? this.realparams?.reisendeResult.children.length : 0);
        this.prs = nbrp + (nbrp > 1 ? ' Personen' : ' Person');
        this.dauer = this.realparams?.reisedauerResult?.name;

        this.createLink();
        this.cdr.detectChanges();
    }

    async getGiataMedia() {
        this.imageList.set([]);
        let giata = this.hotel?.giata?.hotelId;
        if (Number(giata) === 0) {
            giata = this.hotel.tourOperator.code + '_' + this.hotel.code;
        }
        this.trafficsService.request({ giataId: giata, fromdrive: true, hotelcode: this.hotel?.code, tourOperatorList: this.hotel.tourOperator.code, hotelcodetour: this.hotel?.tourOperator.code + '_' + this.hotel?.code }, 'hotels/giataId').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res?.hotel?.code?.length > 0 || res?.hotel?.giata?.hotelId?.length > 0) {
                this.hotel.mediaData = res?.hotel?.mediaData;
                this.hotel.catalogData = res?.hotel?.catalogData;
                const catg = Number(String(res?.hotel?.category).replace(/,/g, '.').replace(/\+/g, ''));
                for (let i = 0; i < Math.floor(catg); i++) {
                    this.categoryAr.push(1);
                }
                if (catg > Math.floor(catg)) {
                    this.categoryAr.push(0.5);
                }
                for (let i = 0; i < this.hotel?.catalogData?.imageList?.length; i++) {
                    this.imageList().push(this.hotel?.catalogData.imageList[i].replace('size=320', 'size=800').replace('size=180', 'size=800'));
                }
            } else {
                this.removeHotel.emit(this.hotel.code);
                this.hotel = null;
            }
            this.loading = false;
            this.cdr.detectChanges();
        });
    }

    async getGiataReviews() {
        const giataId = this.hotel?.giata?.hotelId;
        this.trafficsService.request({ giataId: giataId, source: 'holidaycheck' }, '/hotels/giataId/reviews').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (!res?.error) {
                res.hotelReviewList = res.hotelReviewList?.sort((a, b) => new Date(b.travelDate).getTime() - new Date(a.travelDate).getTime());
                this.hotelReviewList = res as HotelReviewsResponse;
                this.cdr.detectChanges();
            }
        });
    }

    async openReview(ev) {
        ev.stopPropagation();
        if (this.hotelReviewList) {
            let target = {
                autoFocus: false,
                disableClose: true,
            } as MatDialogConfig;
            if (this.mediaService.media() !== 'xs' && this.mediaService.media() !== 'sm') {
                target = { height: '98vh', panelClass: 'customModal', maxWidth: '800px', data: { reviews: this.hotelReviewList, title: this.hotel.name, rating: this.hotel.rating } }
            } else {
                target = { width: '100%', height: '100%', maxWidth: '100%', panelClass: 'customModal', data: { reviews: this.hotelReviewList, title: this.hotel.name, rating: this.hotel.rating } }
            }
            this.dialog.open(HotelreviewComponent, target);
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.hotel,
                images: this.imageList,
                videos: [],
                current: ev,
                to800: true,
                desktopTemplate: this.mediaService.media()
            }
        }
        this.dialog.open(TvangebotimagevideoComponent, target);
    }

    async openMaps() {
        if (this.hotel?.location?.latitude) {
            let target = {
                autoFocus: false,
                disableClose: true,
            } as MatDialogConfig;
            if (this.mediaService.media() !== 'xs') {
                target = { width: '80%', height: '81vh', maxWidth: '100%', panelClass: 'customModal', data: { poi: this.hotel } }
            } else {
                target = { width: '100%', height: '100%', maxWidth: '100%', panelClass: 'customModal', data: { poi: this.hotel } }
            }
            this.dialog.open(MapcomponentComponent, target);
        }
    }

    createLink(): void {
        if (this.realparams) {
            this.realparams.extra = null; // when from sktv 
            const giata = this.hotel?.giata?.hotelId?.length > 1 ? this.hotel?.giata?.hotelId
                : this.hotel?.tourOperator?.code + '_' + this.hotel?.code;
            this.realparams.giataIdList = giata;
            this.realparams.hotelCodeList = this.hotel?.code;
            if (this.hotel?.name?.length > 0) {
                this.realparams.pauschalreiseResult = {
                    data: {
                        name: this.hotel?.name,
                        code: giata
                    },
                    type: 1,
                }
            }
            this.shareLink.set(this.router.createUrlTree([this.guardService.getPartnerId(), 'ibeoffers'], { queryParams: { params: this.encservice.encrypt(this.realparams) } }).toString());
        }
    }

    async goToOffers() {
        const win = window.open('about:blank', '_blank');
        win.location.href = this.shareLink();
        this.trafficsService.request({ giataId: this.hotel?.giata?.hotelId, giataIdG: this.giataIdG }, '/hotels/giataId/recommendationFeedback').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((_) => {
            // TODO
        });
    }

    async addRemoveToFromFavorite(ev) {
        ev.stopPropagation()
        if (this?.inFavorites) {
            this.favoritesService.removeHotel(this.hotel?.code);
            this.inFavorites = false;
        } else {
            this.favoritesService.addHotel(this.hotel, this.realparams);
            this.inFavorites = true;
        }
    }
}
